// Shown during the first /content fetch and during auto-register, before we
// know anything about the screen yet. Same shared FrameMarkDraw as
// PostSetupLoader/PublishingLoader — one consistent "preparing" visual across
// every loading moment.
import FrameMarkDraw from './FrameMarkDraw'

export default function LoadingScreen() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-6 text-center px-5 sm:px-10">
      <FrameMarkDraw />
      <p className="text-white text-[clamp(1rem,4.8vw,1.125rem)] font-medium">We are preparing things for you</p>
    </div>
  )
}
